<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="justify-content-start mb-5">
        <b-col cols="4" sm="3" md="2" xl="1">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <inter-process-configuration-form v-model="config" :readonly="!editMode"></inter-process-configuration-form>
      <b-row class="justify-content-end">
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'create'">
          <b-button v-if="mode === 'create'"
            @click="createConfig" variant="primary">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canEditConfig">
          <b-button variant="primary"
            @click="editModeActivate">
            <i class="fa-light fa-pencil"></i>
            <span>{{ $t('administration.edit') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canDeleteConfig">
          <b-button
            @click="deleteConfig" variant="primary">
            <i class="fa-light fa-trash"></i>
            <span>{{ $t('rights.delete') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === true">
          <b-button variant="primary"
            @click="editConfig">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import InterProcessConfigurationForm from '@/pages/routing/InterProcess/InterProcessConfigurationForm.vue'

import {loadPage} from '@/helpers/routing'

export default {
  name: 'InterProcessConfigurationDetails',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'inter-process-configuration-form': InterProcessConfigurationForm,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.firstOn().rights.rightIs('interProcessConfig_delete', true)
    },
    canEditConfig () {
      return this.$engine.firstOn().rights.rightIs('interProcessConfig_edit', true)
    },
    pageTitle () {
      return this.mode === 'details' ? this.$t('Webheader.interProcess_details') : this.$t('Webheader.interProcess_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      editMode: false,
      name: '',
      returnUrl: '/routing/interProcessConfig/-1',
      savedConfig: [],
      config: {}
    }
  },
  created () {
    this.activateSpinner = true

    if (this.mode === 'details') {
      this.savedConfig = this.$engine.firstOn().routing.config.clickedConfig
      this.fillFields()
      this.$engine.firstOn().routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Name: this.config.name
      }
      this.$engine.firstOn().routing.config.interProcess.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.config_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/interProcessConfig/-1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.config_addition_error'))
      })
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdInterProcess: that.savedConfig.IdInterProcess
              }
              that.$engine.firstOn().routing.config.interProcess.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: '/routing/interProcessConfig/-1'})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Name: this.config.name,
        IdInterProcess: this.savedConfig.IdInterProcess
      }
      this.$engine.firstOn().routing.config.interProcess.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.config_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/interProcessConfig/-1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.config_edition_error'))
      })
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.name = this.savedConfig.Name
    },
    formHasError () {
      if (this.config.name === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: '/routing/interProcessConfig/-1'})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
